module.exports = __webpack_public_path__ + "img/touPhotn.90660ce9.png";